package music.jammers.client.shared.event.domain.usecase

import music.jammers.client.shared.event.domain.repository.CardInfoRepository
import music.jammers.shared.event.domain.model.CardInfo

class GetCardInfoUseCase(
    private val cardInfoRepository: CardInfoRepository,
) {

    suspend operator fun invoke(): List<CardInfo> =
        cardInfoRepository.getAll()
}